import React from 'react';
import PropTypes from 'prop-types';
import { CardLabel, CardTitle } from '../bootstrap/Card';

const StandardPageSubHeader = ({ title }) => {
	return (
		<CardLabel>
			<CardTitle tag='h4' className='h4'>
				{title}
			</CardTitle>
		</CardLabel>
	);
};

StandardPageSubHeader.propTypes = {
	title: PropTypes.string,
};

StandardPageSubHeader.defaultProps = {
	title: '',
};

export default StandardPageSubHeader;
